(function (global) {
  "use strict";

  let _config = null;

  function init(config) {
    _config = config;

    const overlay = _el("ws-modal-overlay");
    if (!overlay) return;

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) showModal(false);
    });

    document.querySelectorAll("[data-ws-close]").forEach(function (btn) {
      btn.addEventListener("click", function () { showModal(false); });
    });

    const form = _el("ws-intake-form");
    if (form) form.addEventListener("submit", _handleFormSubmit);

    const finishBtn = _el("ws-finish-btn");
    if (finishBtn) finishBtn.addEventListener("click", function () { showModal(false); });
  }

  function showModal(show) {
  const overlay = _el("ws-modal-overlay");
  if (!overlay) return;
 
  if (show) {
    const alreadyPanel = _el("ws-step-already");
    if (alreadyPanel) {
      _goToStepId("ws-step-already");
    } else {
      _goToStep(1);
    }
    overlay.classList.add("ws-active");
    document.body.classList.add("ws-no-scroll");
  } else {
    overlay.classList.remove("ws-active");
    document.body.classList.remove("ws-no-scroll");
    const form = _el("ws-intake-form");
    if (form) form.reset();
    _clearError();
  }
}

  async function _handleFormSubmit(e) {
    e.preventDefault();
    _clearError();

    if (!window.WS_CUSTOMER_ID) {
      _showError("You already have account. Please sign in");
      return;
    }

    const form = e.target;
    const fields = {
      eventName: _val(form, "ws-event-name"),
      location:  _val(form, "ws-location"),
      date:      _val(form, "ws-date"),
      firstName: _val(form, "ws-first-name"),
      lastName:  _val(form, "ws-last-name"),
      email:     _val(form, "ws-email"),
      role:      _val(form, "ws-role"),
      marketingConsent: _checked(form, "ws-marketing-consent"),
    };

    const error = _validate(fields);
    if (error) { _showError(error); return; }

    const submitBtn = form.querySelector("[data-ws-submit]");
    _setLoading(submitBtn, true);

    try {
      const res = await fetch('https://33mhd0gxj7.execute-api.us-east-2.amazonaws.com/Wedding_Shop/create_form', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerId: window.WS_CUSTOMER_ID,
          eventName:  fields.eventName,
          location:   fields.location,
          date:       fields.date,
          firstName:  fields.firstName,
          lastName:   fields.lastName,
          email:      fields.email,
          role:       fields.role,
          marketingConsent: String(fields.marketingConsent),
        })
      });

      if (!res.ok) throw new Error("Lambda error: " + res.status);

      const data = await res.json();
      console.log("[WeddingShop] Lambda response:", data);

      await fetch('https://33mhd0gxj7.execute-api.us-east-2.amazonaws.com/Wedding_Shop/step', {   
        method: 'POST',   
        headers: { 'Content-Type': 'application/json' },   
        body: JSON.stringify({     
          customerId: window.WS_CUSTOMER_ID,     
          step: '1'   
        }) 
      });

    } catch (err) {
      console.error("[WeddingShop]", err);
      _showError("There was a problem saving your group. Please try again.");
      _setLoading(submitBtn, false);
      return;
    }

    _setLoading(submitBtn, false);

    const thanksName = _el("ws-thanks-name");
    if (thanksName) thanksName.textContent = fields.firstName + "!";

    _goToStep(2);
  }

  function _validate(f) {
    if (!f.eventName)  return "Please enter an event name.";
    if (!f.location)   return "Please enter a location.";
    if (!f.date)       return "Please enter the event date.";
    if (!f.firstName)  return "Please enter your first name.";
    if (!f.lastName)   return "Please enter your last name.";
    if (!f.email)      return "Please enter your email address.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) return "Please enter a valid email address.";
    if (!f.role)       return "Please select your role.";
    return null;
  }

  function _goToStep(step) {
    document.querySelectorAll("[data-ws-step]").forEach(function (panel) {
      panel.style.display = parseInt(panel.dataset.wsStep) === step ? "" : "none";
    });
  }

  function _goToStepId(id) {
    document.querySelectorAll("[data-ws-step]").forEach(function (panel) {
      panel.style.display = panel.id === id ? "" : "none";
    });
  }

  function _el(id)        { return document.getElementById(id); }
  function _val(form, id) { const el = form.querySelector("#" + id); return el ? el.value.trim() : ""; }
  function _checked(form, id) { const el = form.querySelector("#" + id); return el ? el.checked : false; }
  function _showError(msg)  { const el = _el("ws-form-error"); if (el) { el.textContent = msg; el.style.display = "block"; } }
  function _clearError()    { const el = _el("ws-form-error"); if (el) { el.textContent = ""; el.style.display = "none"; } }
  function _setLoading(btn, loading) {
    if (!btn) return;
    btn.disabled    = loading;
    btn.textContent = loading ? "Saving…" : "Get started";
  }

  global.showModal   = showModal;
  global.WeddingShop = { init, showModal };

})(window);